const DAY = 86_400_000;
const WEEK = 7 * DAY;
const FINAL = 2 * DAY;

/** "ultima zi", "ultimele 2–19 zile", "ultimele 20+ de zile". */
const lastDays = (n) => {
  if (n === 1) return 'ultima zi';
  const rest = n % 100;
  return `ultimele ${n}${rest === 0 || rest >= 20 ? ' de' : ''} zile`;
};

const pad = (n) => String(n).padStart(2, '0');

class SecondPairCountdown extends HTMLElement {
  connectedCallback() {
    // data-end is Unix seconds rendered by Liquid.
    this.end = Number(this.dataset.end) * 1000;
    this.text = this.querySelector('.second-pair-countdown__text');
    this.segments = [...this.querySelectorAll('[data-unit]')];
    if (!this.end || !this.text) return;

    this.update();
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
  }

  update() {
    const left = this.end - Date.now();

    if (left <= 0) {
      // The offer is over: hide the whole message it belongs to.
      (this.closest('[data-second-pair-offer]') ?? this).hidden = true;
      return;
    }

    const s = Math.floor(left / 1000);
    this.dataset.state = left < FINAL ? 'final' : left < WEEK ? 'week' : 'season';

    if (this.segments.length) {
      const values = [Math.floor(s / 86400), Math.floor((s % 86400) / 3600), Math.floor((s % 3600) / 60), s % 60];
      this.segments.forEach((el, i) => (el.textContent = pad(values[i])));
      this.timer = setTimeout(() => this.update(), 1000);
      return;
    }

    let label;
    if (left < FINAL) {
      label = `se încheie în ${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
    } else if (left < WEEK) {
      label = lastDays(Math.ceil(left / DAY));
    } else {
      label = `până pe ${this.dataset.endLabel}`;
    }
    if (this.text.textContent !== label) this.text.textContent = label;

    // Tick every second in the final 48h, otherwise once a minute.
    this.timer = setTimeout(() => this.update(), left < FINAL ? 1000 : 60_000);
  }
}

if (!customElements.get('second-pair-countdown')) {
  customElements.define('second-pair-countdown', SecondPairCountdown);
}
